import React from 'react';
import {History, Location} from "history";
import ContentBlocker from '../../components/context/ContentBlocker';
import {UnsavedChangesConfirmation} from '../../common/NavigationConfirmation';
import SchemaPlayground from '../../components/schema/playground/SchemaPlayground';
import {canCreateSchemaById, noPermissionMessage} from '../../utils/permission-utils';

import schema from '../../template/empty-schema';
import './CreateSchemaPage.scss';

type SchemaPlaygroundPageProps = {
  location: Location;
  history: History;
}

type SchemaPlaygroundPageState = {
  hasChanges: boolean;
}

export default function CreateSchemaPage(props: SchemaPlaygroundPageProps) {
  return (
    <div className="CreateSchemaPage">
      <h1>Create Schema</h1>
      <ContentBlocker checkCreatePermission={true}>
        <SchemaPlaygroundWrapper {...props} />
      </ContentBlocker>
    </div>
  );
}

class SchemaPlaygroundWrapper extends React.Component<SchemaPlaygroundPageProps, SchemaPlaygroundPageState> {

  constructor(props: any) {
    super(props);
    this.state = {
      hasChanges: false,
    };
    this.onSchemaChange = this.onSchemaChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.canCreate = this.canCreate.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
  }

  private onSchemaChange(changedSchema: string, dirty: boolean) {
    this.setState({
      hasChanges: dirty
    });
  }

  private canCreate(schemaId: string): boolean {
    return canCreateSchemaById(schemaId, noPermissionMessage('You do not have permissions to create or update schema with id='));
  }

  private onSave(schemaId: string) {
    this.openSchema(schemaId);
  }

  private onUpdate(schemaId: string) {
    this.openSchema(schemaId);
  }

  private openSchema(schemaId: string) {
    this.props.history.push(`/schema/manage?id=${schemaId}`);
  }

  render() {
    return (
      <>
      <UnsavedChangesConfirmation when={this.state.hasChanges}
                                  message={CreateSchemaUnsavedChangesMessage}/>
      <SchemaPlayground schema={schema}
                        isTemplate={true}
                        onChange={this.onSchemaChange}
                        canCreate={this.canCreate}
                        onSave={this.onSave}
                        onUpdate={this.onUpdate}/>
      </>
    );
  }
}

function CreateSchemaUnsavedChangesMessage() {
  return (
    <p>Are you sure you want to leave this page? The changes you made will be lost!</p>
  );
}
